import { receiptPdf, serverPdf, SERVER_PDF_ERROR, AuditLogService } from "app-core";
import { usePdfActions } from "./index44.js";
function useReceiptPdf(order, print, host) {
  const source = () => {
    const shown = order();
    return shown ? { order: shown, ...print() } : null;
  };
  let sent = null;
  return usePdfActions({
    available: () => serverPdf.supports("receipt"),
    offered: () => receiptPdf.isOffered(order()),
    missingHint: () => void 0,
    documentLine: () => {
      const shown = order();
      return shown ? receiptPdf.documentLine(shown) : "";
    },
    defaultRecipient: () => {
      var _a, _b;
      return ((_b = (_a = order()) == null ? void 0 : _a.getClient()) == null ? void 0 : _b.email) || "";
    },
    save: () => {
      const shown = source();
      return shown ? receiptPdf.save(shown, host.endpointBase) : Promise.resolve({ success: false, error: SERVER_PDF_ERROR.general });
    },
    email: (to) => {
      const shown = source();
      sent = (shown == null ? void 0 : shown.order) ?? null;
      return shown ? receiptPdf.email(shown, to, host.endpointBase) : Promise.resolve({ success: false, error: SERVER_PDF_ERROR.general });
    },
    afterSent: async (to) => {
      if (!sent) return;
      await AuditLogService.info({
        type: "email_receipt",
        email: to,
        value: sent.getToPay().abs().toFormat("0.00") || "0.00",
        receiptHash: sent.hash
      });
    }
  }, host);
}
export {
  useReceiptPdf
};
//# sourceMappingURL=index47.js.map
